import { Fragment, PureComponent } from "react";
import { BIGBRAIN_IFRAME_LOCALSTORAGE_EVENTS } from "/constants/bigbrain-event-types";
import Head from "next/head";
import BigBrainScript from "/components/core/head/bigbrain-script";
import {
  CLUSTERS,
  SIGNUP_REFERRER,
  UTM_ADGROUP,
  UTM_BANNER,
  UTM_CAMPAIGN,
  UTM_KEYWORD,
  UTM_MEDIUM,
  UTM_SOURCE,
  LANDING_PAGE
} from "/constants/localstorage";

const isProduction = process.env.NODE_ENV === "production";
const PAGE_TYPE = "external_sync";
const BIGBRAIN_QUEUE = "_event_tracker_queue";

export default class HomepageSyncComponent extends PureComponent {
  parentCommunicationScriptGenerator = () => {
    const { parentTargetOrigin } = this.props;
    //  sending data for auth pages:
    return `
        const data = { 
            clusters: JSON.parse(localStorage.getItem('${CLUSTERS}')),
            signupCampaignData: {
                utm_adgroup: JSON.parse(localStorage.getItem('${UTM_ADGROUP}')),
                utm_banner: JSON.parse(localStorage.getItem('${UTM_BANNER}')),
                utm_campaign: JSON.parse(localStorage.getItem('${UTM_CAMPAIGN}')),
                utm_keyword: JSON.parse(localStorage.getItem('${UTM_KEYWORD}')),
                utm_medium: JSON.parse(localStorage.getItem('${UTM_MEDIUM}')),
                utm_source: JSON.parse(localStorage.getItem('${UTM_SOURCE}')),
                signup_referrer: JSON.parse(localStorage.getItem('${SIGNUP_REFERRER}')),
                landing_page: JSON.parse(localStorage.getItem('${LANDING_PAGE}')),
            }
        };
        window.parent.postMessage(JSON.stringify(data), '${parentTargetOrigin}');
    `;
  };

  bigBraingQueueTracker = () => {
    return `
    let itemsInQueue;
    try {
      itemsInQueue = JSON.parse(localStorage.getItem("${BIGBRAIN_QUEUE}"));
    } catch (e) {}
    document.addEventListener("DOMContentLoaded", () => {
      BigBrain("track", "${BIGBRAIN_IFRAME_LOCALSTORAGE_EVENTS}", { info1: itemsInQueue?.length });
    });`;
  };

  render() {
    return (
      <>
        <Head>
          <script
            dangerouslySetInnerHTML={{
              __html: this.bigBraingQueueTracker()
            }}
          />
          <BigBrainScript
            isProduction={isProduction}
            pageType={PAGE_TYPE}
            preventPageView={true}
            createVisitor={false}
          />
        </Head>
        <script
          dangerouslySetInnerHTML={{
            __html: this.parentCommunicationScriptGenerator()
          }}
        />
      </>
    );
  }
}
